var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "full-screen-container flex justify-between" },
    [
      _c(
        "div",
        { staticClass: "full-left" },
        [
          _c("Conversation", {
            ref: "conversation",
            on: {
              change: _vm.changeConversation,
              setWordExtractIndex: _vm.setWordExtractIndex,
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "full-center relative" },
        [
          _c("div", { staticClass: "full-center-header" }, [
            !_vm.isAICenter && _vm.isScene && !_vm.isScene.isDeleted
              ? _c("i", {
                  staticClass: "el-icon-more",
                  on: { click: _vm.openAidetail },
                })
              : _vm._e(),
            !_vm.isIgnore
              ? _c("img", {
                  attrs: {
                    src: require("@/assets/image/aigc/slidebar.png"),
                    alt: "",
                  },
                  on: { click: _vm.closeFullScreen },
                })
              : _vm._e(),
            _c("img", {
              attrs: { src: require("@/assets/image/aigc/close.png"), alt: "" },
              on: { click: _vm.closeALL },
            }),
          ]),
          _c(
            "div",
            {
              ref: "fullCenterContentRef",
              class: [
                "full-center-content",
                _vm.isShowDragMask ? "child-disable-click" : "",
              ],
              staticStyle: { position: "relative" },
              on: {
                dragenter: function ($event) {
                  $event.preventDefault()
                  return _vm.handleDragEnter.apply(null, arguments)
                },
                dragover: function ($event) {
                  $event.preventDefault()
                },
                dragleave: function ($event) {
                  $event.stopPropagation()
                  return _vm.handleDragLeave.apply(null, arguments)
                },
                drop: function ($event) {
                  $event.preventDefault()
                  return _vm.handleDrop.apply(null, arguments)
                },
              },
            },
            [
              _vm.getIsShowWordExtract && _vm.isShow
                ? _c("ChatExtract", {
                    staticStyle: { width: "100%" },
                    attrs: { "word-extract-index": _vm.wordExtractIndex },
                  })
                : _c(
                    "div",
                    { staticClass: "full-center-content-chat" },
                    [
                      _vm.isAICenter
                        ? _c("aiCenter", {
                            on: {
                              openAi: _vm.openAi,
                              onAdd: _vm.onhandleAdd,
                              editAi: _vm.editAi,
                            },
                          })
                        : _vm._e(),
                      _vm.getIsShowHotspot ? _c("Hotspot") : _vm._e(),
                      _vm.getIsShowEMOVideo ? _c("EMOVideo") : _vm._e(),
                      !_vm.isAICenter &&
                      !_vm.getIsShowHotspot &&
                      !_vm.getIsShowWordExtract &&
                      !_vm.getIsShowEMOVideo
                        ? [
                            _c("ChatFrame", {
                              ref: "chatFrameRefs",
                              class: {
                                "chat-frame": true,
                                "chat-frame-is":
                                  _vm.getIsShowImageGeneration ||
                                  _vm.getIsShowDouyinBZhangGuide,
                              },
                              on: {
                                setInput: _vm.setInput,
                                resetAnswer: _vm.resetAnswer,
                                createTopic: _vm.createTopic,
                                openRevision: _vm.openRevision,
                                collectSearch: _vm.collectSearch,
                              },
                            }),
                            _c(
                              "div",
                              {
                                staticClass: "center-bottom",
                                style: {
                                  "padding-top":
                                    _vm.getIsShowImageGeneration ||
                                    _vm.getIsShowDouyinBZhangGuide
                                      ? "24px"
                                      : "0px",
                                },
                              },
                              [
                                !_vm.getIsShowImageGeneration &&
                                !_vm.getIsShowDouyinBZhangGuide
                                  ? _c("div", { staticClass: "operate-row" }, [
                                      _c(
                                        "div",
                                        { staticClass: "flex left-operate" },
                                        [
                                          !_vm.getIsShowDouyinBZhangGuide &&
                                          !_vm.getisDeleted
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "left-fn",
                                                  on: {
                                                    click: _vm.restartSession,
                                                  },
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: require("@/assets/image/aigc/Message-failed.png"),
                                                      alt: "",
                                                    },
                                                  }),
                                                  _vm._v(" 全新对话 "),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.isScene.templateId ===
                                          "1964890341809664006"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "left-fn ml-2 relative tip-relative",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "flex" },
                                                    [
                                                      _c("img", {
                                                        staticClass:
                                                          "mt-1 mr-1",
                                                        attrs: {
                                                          src: require("@/assets/image/aigc/tp.png"),
                                                          alt: "",
                                                        },
                                                      }),
                                                      _c("span", [
                                                        _vm._v("提示词例"),
                                                      ]),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "absolute tip-word",
                                                    },
                                                    _vm._l(
                                                      _vm.ptPrompt,
                                                      function (item, index) {
                                                        return _c(
                                                          "p",
                                                          {
                                                            key: index,
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.setChangeValue(
                                                                  item
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(item) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.isLiveAssistant &&
                                          !_vm.getisDeleted
                                            ? _c("LiveAssistantButtons", {
                                                on: {
                                                  "function-click":
                                                    _vm.handleFunctionClick,
                                                },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ])
                                  : _vm._e(),
                                !_vm.getisDeleted &&
                                !_vm.getIsShowVideoExtractInput
                                  ? _c("ChatInput", {
                                      ref: "chatInputRefs",
                                      attrs: { content: _vm.activeItemContent },
                                      on: { userInput: _vm.userInput },
                                    })
                                  : _c(
                                      "div",
                                      { staticClass: "chatDeletedInput" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.getIsShowVideoExtractInput
                                                ? "助手已停止使用，请使用新版视频文案提取助手。"
                                                : "助手已停止使用，请更换其他助手。"
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
              _c(
                "aiDrawer",
                { attrs: { visbile: _vm.drawerConfig.visbile } },
                [
                  _vm.drawerConfig.visbile
                    ? _c(_vm.drawerConfig.type, {
                        tag: "component",
                        on: { close: _vm.openAidetail },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm.getNewsList().length > 0 ? _c("NewsList") : _vm._e(),
              _vm.getModelType() === 2
                ? _c("DragMask", {
                    attrs: { visible: _vm.isShowDragMask },
                    on: {
                      "update:visible": function ($event) {
                        _vm.isShowDragMask = $event
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "wrapPage",
            {
              attrs: { visbile: _vm.wrapPageConfig.visbile && _vm.isAICenter },
            },
            [
              _vm.wrapPageConfig.visbile && _vm.isAICenter
                ? _c(_vm.wrapPageConfig.type, {
                    tag: "component",
                    attrs: { config: _vm.wrapPageConfig },
                    on: {
                      closePage: function ($event) {
                        _vm.wrapPageConfig.visbile = false
                      },
                      success: _vm.onhandleReshreList,
                      addSuccess: _vm.addSuccess,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("customDialog", {
        attrs: { list: _vm.custonComponentList },
        on: {
          close: function ($event) {
            _vm.visibleCustomDialog = false
          },
        },
        model: {
          value: _vm.visibleCustomDialog,
          callback: function ($$v) {
            _vm.visibleCustomDialog = $$v
          },
          expression: "visibleCustomDialog",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }